var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.27173 10C5.17173 10 4.27173 10.9 4.27173 12C4.27173 13.1 5.17173 14 6.27173 14C7.37173 14 8.27173 13.1 8.27173 12C8.27173 10.9 7.37173 10 6.27173 10ZM18.2717 10C17.1717 10 16.2717 10.9 16.2717 12C16.2717 13.1 17.1717 14 18.2717 14C19.3717 14 20.2717 13.1 20.2717 12C20.2717 10.9 19.3717 10 18.2717 10ZM12.2717 10C11.1717 10 10.2717 10.9 10.2717 12C10.2717 13.1 11.1717 14 12.2717 14C13.3717 14 14.2717 13.1 14.2717 12C14.2717 10.9 13.3717 10 12.2717 10Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.ebd9e904589a86870c4b2e715ee69a78.svg";
export { ForwardRef as ReactComponent };